/**
 * Step 2 — Finance & Reporting [TYPE D — Hard Selection]
 *
 * GP calculation method and revenue display mode are one-time decisions
 * that affect every P&L report in the system.
 * Next is DISABLED until the user has actively confirmed a selection.
 * Embeds General Settings → Reporting tab.
 */

import { StepWrapper } from '../StepWrapper';
import { SettingsGeneralPage } from '@/pages/settings-general';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step2FinanceReporting({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="Review your GP calculation method and revenue settings before continuing."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      {/* Informational nudge */}
      <div className="mb-4 rounded-lg bg-warning-50 border border-warning-200 px-4 py-3">
        <p className="text-sm text-warning-800">
          <strong>Important.</strong> Your GP calculation method and revenue
          display mode determine how all P&amp;L reports are calculated. These settings
          are difficult to change once project data exists — review them carefully.
        </p>
      </div>

      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsGeneralPage defaultTab="reporting" />
      </div>
    </StepWrapper>
  );
}
